/**
 * The Discussions nav badge (T2): the number of UNREAD `comment_reply` +
 * `comment_mention` notifications, counted from the cached first page of the
 * shared `['notifications']` feed (`useUnreadCommentCount` in
 * `features/notif/api.ts`). Cheap by construction — one list request per
 * staleness window, shared with `/notifications` and the Discussions inbox,
 * nothing per row, and no poller of its own: the list is re-fetched only when
 * the nav's existing unread-count query reports a higher total.
 *
 * Opening Replies / Mentions in the inbox marks the feed read (the API only
 * has mark-all), which clears this badge.
 */

import { useUnreadCommentCount } from '@/features/notif/api';

export function useDiscussionsBadge(): number {
  return useUnreadCommentCount();
}
